import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import StyledMenu from "../../../components/layout/StyledMenu";
import { postNotification } from "../../../components/utilities/Notifications";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";

import ListResponsive from "../../../components/other/ListResponsive";

import { Formik } from "formik";
import { useConfirm } from "material-ui-confirm";
import {
  BCPEllipsisVertical,
  BCPLinkSimple,
  BCPLockKeyhole,
  BCPLockKeyholeOpen,
  BCPSquarePlus,
  BCPUserMagnifyingGlass,
  BCPXmark,
} from "../../../components/icons/bcp/BCPIcons";
import {
  getData,
  postData,
} from "../../../components/utilities/UtilityFunctions";

const convertUsersToArray = async (team) => {
  var users = [];
  if (team.members) {
    Object.values(team.members).forEach((user) => {
      users.push(user);
    });
  }

  if (team.users?.length) {
    for (var i = 0; i < team.users.length; i++) {
      if (!team.members?.[team.users[i].objectId]) {
        var user = await getData(`/users/${team.users[i].objectId}`);
        users.push(user);
      }
    }
  }

  users.sort((a, b) => {
    if (a.id === team.ownerId) return -1;
    if (b.id === team.ownerId) return 1;
    if ((a.firstName || a.lastName) && (b.firstName || b.lastName)) {
      var nameA = `${a.firstName} ${a.lastName}`.toLowerCase().trim();
      var nameB = `${b.firstName} ${b.lastName}`.toLowerCase().trim();
      if (nameA > nameB) return 1;
      if (nameA < nameB) return -1;
    } else if (a.firstName || a.lastName) {
      return 1;
    } else if (b.firstName || b.lastName) {
      return -1;
    }
    return 0;
  });

  return users;
};

export default function TeamUsers(props) {
  const { team, setTeam, authContext } = props;

  const [processing, setProcessing] = useState(false);
  const [subLoading, setSubLoading] = useState(true);
  const [teamUsers, setTeamUsers] = useState(null);
  const [teamUser, setTeamUser] = useState(null);

  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [optionsTeamUser, setOptionsTeamUser] = useState(null);

  const [readOnly, setReadOnly] = useState(team?.id && !team?.isOwner);
  const [memberReadOnly, setMemberReadOnly] = useState(
    team?.id && !team?.isMember
  );

  useEffect(() => {
    const check = async () => {
      var apiUsers = await convertUsersToArray(team);
      setTeamUsers(apiUsers);
      setSubLoading(false);
    };
    check();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Grid container sx={{ gap: 2 }}>
        {team?.id &&
          team?.ownerId !== authContext?.authState?.identity?.userId &&
          authContext?.authState?.identity?.isAdmin === true && (
            <Grid item xs={12}>
              <Typography variant="h5">
                <Button
                  color="primary"
                  variant="outlined"
                  fullWidth
                  onClick={() => {
                    setReadOnly(!readOnly);
                    setMemberReadOnly(!memberReadOnly);
                  }}
                  endIcon={
                    readOnly ? (
                      <BCPLockKeyhole outlined />
                    ) : (
                      <BCPLockKeyholeOpen outlined />
                    )
                  }
                >
                  {readOnly ? "Locked" : "Unlocked"}
                </Button>
              </Typography>
            </Grid>
          )}

        <Grid item xs={12}>
          <ListResponsive
            originalList={subLoading ? null : teamUsers}
            doSearch
            doPages
            initialRowsPerPage={25}
            actionButton={
              !readOnly || !memberReadOnly
                ? [
                    {
                      props: {
                        variant: "contained",
                        color: "primary",
                        onClick: () => {
                          setTeamUser({});
                        },
                        startIcon: <BCPSquarePlus />,
                      },
                      label: "Add User",
                    },
                  ]
                : null
            }
            searchProps={{
              label: "Search Users",
              performSearch: (originalList, searchText) => {
                if (!searchText || searchText === "") {
                  return originalList;
                } else {
                  var filteredList = originalList.filter(function (el) {
                    if (el?.firstName?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.lastName?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.email?.toLowerCase().includes(searchText))
                      return true;

                    return false;
                  });
                  return filteredList;
                }
              },
            }}
            rowProps={{
              mapFunction: (row, index) => (
                <Grid
                  key={index}
                  item
                  xs={12}
                  onClick={
                    !readOnly
                      ? () => {
                          setTeamUser(row);
                        }
                      : null
                  }
                  sx={{
                    "&:hover": !readOnly
                      ? {
                          cursor: "pointer",
                        }
                      : {},
                  }}
                >
                  <Grid container sx={{ m: 1 }}>
                    <Grid item xs>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: row.id === team.ownerId && "600" }}
                      >
                        {`${row.firstName} ${row.lastName}`}
                      </Typography>

                      <Typography variant="caption" sx={{ height: "14px" }}>
                        {row.role}
                      </Typography>
                    </Grid>
                    {!readOnly && (
                      <Grid
                        item
                        xs
                        sx={{ maxWidth: "45px", textAlign: "right", pb: 1 }}
                      >
                        <IconButton
                          sx={{
                            color: "info.contrastText",
                            backgroundColor: "info.main",
                            "&:hover": { backgroundColor: "info.dark" },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setOptionsTeamUser(row);
                            setOptionsAnchorEl(e.currentTarget);
                          }}
                        >
                          <BCPEllipsisVertical />
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>
                  <Divider sx={{ mt: 1, mb: 1 }} />
                </Grid>
              ),
            }}
          />
        </Grid>
      </Grid>
      <TeamUserModal
        team={team}
        setTeam={setTeam}
        teamUser={teamUser}
        setTeamUser={setTeamUser}
        teamUsers={teamUsers}
        setTeamUsers={setTeamUsers}
        setProcessing={setProcessing}
      />
      <OptionsMenu
        anchorEl={optionsAnchorEl}
        setAnchorEl={setOptionsAnchorEl}
        team={team}
        setTeam={setTeam}
        teamUser={optionsTeamUser}
        setTeamUser={setOptionsTeamUser}
        setTeamUsers={setTeamUsers}
        setProcessing={setProcessing}
        authContext={authContext}
      />

      {Boolean(processing) && <ModalLoadingFull />}
    </>
  );
}

function OptionsMenu(props) {
  const {
    anchorEl,
    setAnchorEl,
    team,
    setTeam,
    teamUser,
    setTeamUser,
    setTeamUsers,
    setProcessing,
  } = props;
  const confirm = useConfirm();
  const open = Boolean(anchorEl);
  return (
    <>
      <StyledMenu
        id="options-menu"
        MenuListProps={{
          "aria-labelledby": "options-button",
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={async (e) => {
            setAnchorEl(null);

            try {
              await confirm({
                title: `Change Ownership.`,
                description: `Are you sure you want to set ${`${
                  teamUser.firstName || ""
                } ${
                  teamUser.lastName || ""
                }`.trim()} as the new owner of this team?`,
                dialogProps: {
                  sx: {
                    zIndex: 99999,
                  },
                },
              });
            } catch (err) {
              setTeamUser(null);
              return;
            }
            setProcessing(true);

            try {
              var newTeam = await postData(`/teams/${team.id}`, {
                body: {
                  set: {
                    ownerId: teamUser.id,
                  },
                },
              });

              setTeam(newTeam);

              var apiUsers = await convertUsersToArray(newTeam);
              setTeamUsers(apiUsers);
              setTeamUser(null);
            } catch (err) {
              postNotification("error", err);
            }
            setProcessing(false);
          }}
          disableRipple
        >
          Set as Owner
        </MenuItem>
        <MenuItem
          onClick={async () => {
            setAnchorEl(null);
            if (teamUser.id === team.ownerId) {
              postNotification(
                "error",
                "You cannot remove the owner of a team."
              );
              return;
            }
            try {
              await confirm({
                title: `Remove from Team.`,
                description: `Are you sure you want to remove ${`${
                  teamUser.firstName || ""
                } ${teamUser.lastName || ""}`.trim()} from the team?`,
                dialogProps: {
                  sx: {
                    zIndex: 99999,
                  },
                },
              });
            } catch (err) {
              setTeamUser(null);
              return;
            }
            setProcessing(true);

            try {
              var newTeam = await postData(`/teams/${team.id}/removeMember`, {
                body: {
                  userId: teamUser.id,
                },
              });

              setTeam(newTeam);

              var apiUsers = await convertUsersToArray(newTeam);
              setTeamUsers(apiUsers);
              setTeamUser(null);
            } catch (err) {
              postNotification("error", err);
            }
            setProcessing(false);
          }}
          disableRipple
        >
          Remove from Team
        </MenuItem>
      </StyledMenu>
    </>
  );
}

function TeamUserModal(props) {
  const {
    team,
    setTeam,
    teamUser,
    setTeamUser,
    teamUsers,
    setTeamUsers,
    setProcessing,
  } = props;

  const isOwner = team?.ownerId && team?.userId === team?.ownerId;

  const searchUser = async (email, setFieldValue) => {
    var apiUser;
    if (email !== "") {
      setProcessing(true);
      try {
        apiUser = await getData(`/users/${email}`, {
          queryStringParameters: {},
        });
      } catch (err) {}
      setProcessing(false);
    }

    if (
      apiUser?.id &&
      teamUsers.filter(function (el) {
        return el?.id === apiUser.id;
      }).length > 0
    ) {
      postNotification("error", "User is already assigned to the Team");

      setFieldValue("userId", null);
      setFieldValue("firstName", "");
      setFieldValue("lastName", "");
      return;
    }
    setFieldValue("userId", apiUser?.id || null);
    setFieldValue("firstName", apiUser?.firstName || "");
    setFieldValue("lastName", apiUser?.lastName || "");

    if (!apiUser?.id) {
      postNotification("error", "User not found");
    }
  };

  return (
    <Modal
      disableAutoFocus
      open={Boolean(teamUser)}
      onClose={() => {
        setTeamUser(null);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      {teamUser ? (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setTeamUser(null);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs>
              <Typography variant="h4" component="h2">
                {isOwner
                  ? "Team Owner"
                  : teamUser.id
                  ? "Update User"
                  : "Create User"}
              </Typography>
            </Grid>
          </Grid>
          <Formik
            initialValues={{
              userId: teamUser?.id || null,
              email: teamUser?.email || "",
              firstName: teamUser?.firstName || "",
              lastName: teamUser?.lastName || "",
              nickname: teamUser?.nickname || "",
              role: teamUser?.role || "Member",
            }}
            enableReinitialize
            onSubmit={async (values) => {
              var apiData;
              setProcessing(true);
              try {
                if (teamUser.id) {
                  var newMembers = {};
                  var newUsers = [];
                  teamUsers.forEach((user) => {
                    if (!newMembers[user.id]) {
                      newMembers[user.id] = {
                        id: user.id,
                        firstName: user.firstName,
                        lastName: user.lastName,
                        nickname: user.nickname,
                        role: user.id === teamUser.id ? values.role : user.role,
                      };
                      newUsers.push({
                        __type: "Pointer",
                        className: "_User",
                        objectId: user.id,
                      });
                    }
                  });
                  let sanitizedValues = {
                    members: newMembers,
                    users: newUsers,
                  };

                  var body = {
                    set: sanitizedValues,
                  };

                  apiData = await postData(`/teams/${team.id}`, {
                    body: body,
                  });
                } else {
                  let sanitizedValues = {
                    userId: values.userId,
                    role: values.role,
                  };

                  apiData = await postData(`/teams/${team.id}/addMember`, {
                    body: sanitizedValues,
                  });
                }

                var newTeam = {
                  ...team,
                  ...apiData,
                };
                setTeam(newTeam);

                var apiUsers = await convertUsersToArray(newTeam);
                setTeamUsers(apiUsers);

                setTeamUser(null);
                setProcessing(false);
                return;
              } catch (err) {
                postNotification("error", err);
                setProcessing(false);
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <TextField
                      label="Email"
                      name="email"
                      value={values.email}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      disabled={Boolean(teamUser.id)}
                      required
                      InputProps={{
                        endAdornment: teamUser.id ? (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Copy Email"
                              edge="end"
                              color="primary"
                              onClick={() => {
                                navigator.clipboard.writeText(values.email);
                              }}
                            >
                              <BCPLinkSimple />
                            </IconButton>
                          </InputAdornment>
                        ) : (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Search"
                              edge="end"
                              color="primary"
                              onClick={async () => {
                                await searchUser(values.email, setFieldValue);
                              }}
                            >
                              <BCPUserMagnifyingGlass />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      onBlur={async (e) => {
                        handleBlur(e);
                        await searchUser(e.target.value, setFieldValue);
                      }}
                      onChange={(e) => {
                        const trimmedString = e.target.value
                          .trim()
                          .toLowerCase();
                        setFieldValue("email", trimmedString);
                      }}
                      error={Boolean(touched.email && errors.email)}
                      helperText={touched.email && errors.email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="First Name"
                      value={values.firstName}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Last Name"
                      value={values.lastName}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Nickname"
                      value={values.nickname}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Role"
                      name="role"
                      value={values.role}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      required
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(touched.role && errors.role)}
                      helperText={touched.role && errors.role}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        setTeamUser(null);
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="success"
                      type="submit"
                      disabled={isOwner || !values.userId}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        <></>
      )}
    </Modal>
  );
}
